import * as React from "react";
export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fill="#01579b"
        d="M11.25 0L11.25 11.25L0 11.25L0 12.75L11.25 12.75L11.25 24L12.75 24L12.75 12.75L24 12.75L24 11.25L12.75 11.25L12.75 0L11.25 0Z"
      />
    </svg>
  );
};
